<div class="page-chart-wrapper col-12">
    <h5 class="text-primary" *ngIf="pageChartData.reviewAgentId">{{pageChartData.reviewAgentName}}</h5>
    <chart [options]="chartOptions" (load)="onChartLoad($event.context)"></chart>
</div>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/page/page-review-scores-chart/page-review-scores-chart.component.html